// Centralized time tracking category configuration
// This should match server/initialize-time-tracking.ts

export interface TimeCategory {
  id: string;
  name: string;
  color: string;
  category: 'tracked' | 'budget';
}

// Default categories matching backend initialization
export const DEFAULT_TIME_CATEGORIES: TimeCategory[] = [
  { id: 'production', name: 'Production Time', color: '#6989c4', category: 'tracked' },
  { id: 'changes', name: 'Changes Time', color: '#3e5275', category: 'tracked' },
  { id: 'other', name: 'Other Time', color: '#374151', category: 'tracked' },
  { id: 'problem_solving', name: 'Problem-Solving Time', color: '#ff8357', category: 'tracked' },
  { id: 'budgeted', name: 'Budgeted Time', color: '#0f8f67', category: 'budget' },
  { id: 'changes_budget', name: 'Changes Budget', color: '#0b5039', category: 'budget' },
];

// Fallback color for unknown categories
export const FALLBACK_COLOR = '#6b7280';

// Helper to get category by ID with fallback
export function getCategoryById(categoryId: string, categories: TimeCategory[] = DEFAULT_TIME_CATEGORIES): TimeCategory {
  const category = categories.find(c => c.id === categoryId);
  if (!category) {
    // Return a fallback category
    return {
      id: categoryId,
      name: categoryId.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      color: FALLBACK_COLOR,
      category: 'tracked'
    };
  }
  return category;
}
